module.exports = __webpack_public_path__ + "img/difemsa.06df40ff.png";